import { useQuery } from '@tanstack/react-query';
import { browserClient } from '../../../react-query';
import { GlobalReactQueryOptions } from '../../../config';
import { fetchHasRemovableCopy } from './fetchHasRemovableCopy';

const HAS_REMOVABLE_COPY_QUERY_KEY = 'hasRemovableCopy';

export const useHasRemovableCopy = (productId: string | null) => {
    return useQuery(
        [HAS_REMOVABLE_COPY_QUERY_KEY, productId],
        () => (productId ? fetchHasRemovableCopy(productId) : Promise.resolve(false)),
        {
            ...GlobalReactQueryOptions,
            enabled: !!productId
        }
    );
};

export const invalidateHasRemovableCopy = (productId: string) => {
    return browserClient.invalidateQueries([HAS_REMOVABLE_COPY_QUERY_KEY, productId]);
};
